import { Paragraph } from '@eggplant/pattern-library'

const description = 'You can now enter your new space and start testing.'

const alternateDescription = 'Or, you can perform the actions below to finish setting up your space. You can also complete these tasks later from the Manage Space page.'

const SpaceCreatedInfo = () =>
  <Paragraph>
    <strong>
      {description}
      <br />
      <br />
      {alternateDescription}
    </strong>
  </Paragraph>

export default SpaceCreatedInfo
